import { IResult, RestClient } from 'slipstream-components';
import convertSingleServiceResult from '../common/convertSingleServiceResult';
import ICustomerEntity from '../entities/CustomerEntity';

const restClient = new RestClient();
const customerAPI = {
  async getCustomersByParentId(parentId: string): Promise<IResult> {
    return restClient.get('/tssm/customer', ['parent_id=' + parentId, 'detail=true']);
  },

  async getCustomerByUuid(customerUuid: string): Promise<ICustomerEntity> {
    const response = restClient.get('/tssm/customer/' + customerUuid);
    return convertSingleServiceResult(response, 'customer');
  },
};

export default customerAPI;
